const categoryControls = () =>{
    const filterToggle = document.getElementById('ume-starter-filter-cat-toggle');
    if(filterToggle){
        filterToggle.addEventListener('click', ev => {
            let expanded = filterToggle.getAttribute('aria-expanded');

            let targetSpace = document.getElementById('ume-starter-filter-cat-content');
            if(expanded === 'false'){
                filterToggle.setAttribute('aria-expanded', 'true');
                targetSpace.classList.remove('d-none');
            }
            if(expanded === 'true'){
                filterToggle.setAttribute('aria-expanded', 'false');
                targetSpace.classList.add('d-none');
            }
        })
    }
}
export default categoryControls;